<div class="related-item">
  <a href={link}>
    <div class="related-img"><img src={cover} alt={title} /></div>
    <div class="related-item"><span>{title}</span></div>
  </a>
</div>

<style>
  .related-item {
    text-align: left;
    &:not(:last-child) {
      margin-bottom: 20px;
    }
    a {
      color: black;
      img {
        width: 100%;
      }
    }
  }
</style>